import { Injectable } from '@angular/core';
import { Price } from '../models/price';
import { HttpClient } from '@angular/common/http';
import { Direction } from '../models/direction';

@Injectable()
export class StateService {
  private topOrders: Map<string, Map<Direction, Array<Price>>> = new Map<
    string,
    Map<Direction, Array<Price>>
  >();
  private spotPrices: any;
  private graphData: any;
  private swapHistory: any[] = [];
  private tabs: any[] = [];
  private trades: any[] = [];
  private orders: any[] = [];
  private currencyPairs: any[];
  private lastTradePrices: any;
  private onBehalfUsers: Array<any>;
  private selectedOnBehalfUser: string;
  private currencyMappings: Array<any>;
  private allOrders: Array<any>;

  constructor(private httpClient: HttpClient) {}

  setTopOrders(topOrders: Map<string, Map<Direction, Array<Price>>>) {
    this.topOrders = topOrders;
  }

  getTopOrdersForCurrencyPair(cp): Map<Direction, Array<Price>> {
    return this.topOrders[cp];
  }

  setSpotPrices(spotPrices: any) {
    this.spotPrices = spotPrices;
  }

  getSpotPriceForCurrencyPair(ccyPair: string) {
    if (!this.spotPrices) {
      return null;
    }
    let cp = ccyPair;
    if (cp.toUpperCase().includes('USC')) {
      cp = cp.replace('USC', 'USD');
    }
    if (cp.toUpperCase().includes('PAX')) {
      cp = cp.replace('PAX', 'USD');
    }
    const mapping: any | null = this.currencyMappings.find(
      (item) => item[0].toUpperCase() === cp.toUpperCase(),
    );
    const spotPrice = this.spotPrices[mapping ? mapping[1] : cp];
    if (!spotPrice) {
      const invertedPrice = this.spotPrices[cp.slice(3, 6) + cp.slice(0, 3)];
      return invertedPrice ? 1 / invertedPrice : null;
    }
    return spotPrice;
  }

  getSpotPrices(): any {
    return this.spotPrices;
  }

  getState() {
    return this.httpClient.get('/rl/api/price/state');
  }

  setGraphData(data) {
    this.graphData = data;
  }

  getGraphData() {
    return this.graphData;
  }

  getGraphDataForCP(cp: string) {
    return this.graphData[cp];
  }

  setSwapHistory(swapHistory) {
    this.swapHistory = swapHistory;
  }

  getSwapHistory() {
    return this.swapHistory;
  }

  setTabs(tabs) {
    this.tabs = tabs;
  }

  getTabs() {
    return this.tabs;
  }

  setTrades(trades) {
    this.trades = trades;
  }

  getTrades() {
    return this.trades;
  }

  setOrders(orders) {
    this.orders = orders;
  }

  getOrders() {
    return this.orders;
  }

  setCurrencyPairs(currencyPairs) {
    this.currencyPairs = currencyPairs;
  }

  getCurrencyPairs() {
    return this.currencyPairs;
  }

  setLastTradePrices(lastTradePrices) {
    this.lastTradePrices = lastTradePrices;
  }

  getLastTradePrices() {
    return this.lastTradePrices;
  }

  setOnBehalfUsers(onBehalfUsers) {
    this.onBehalfUsers = onBehalfUsers;
  }

  getOnBehalfUsers() {
    return this.onBehalfUsers;
  }

  setSelectedOnBehalfUser(onBehalfUser: string) {
    this.selectedOnBehalfUser = onBehalfUser;
  }

  getSelectedOnBehalfUser() {
    return this.selectedOnBehalfUser;
  }

  setCurrencyMappings(value: [[]]) {
    this.currencyMappings = value;
  }

  getAllOrders(): Array<any> {
    return this.allOrders;
  }

  setAllOrders(value: Array<any>) {
    this.allOrders = value;
  }
}
